module.exports = __webpack_public_path__ + "img/linse_pre_oven.e29b4aae.jpg";